import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage, Messaging } from 'firebase/messaging';

// Firebase configuration from environment variables
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyAXk_TD-2DtqzwVd4LSdWjp8lc1ppMC0so",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "erp-affordable.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "erp-affordable",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "erp-affordable.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "1026950916475",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:1026950916475:web:bfe162330e4e8fcadab5de",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-GW7MR2RFBC"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Get messaging instance - may fail in unsupported browsers
let messaging: Messaging | null = null;
try {
  messaging = getMessaging(app);
} catch (error) {
  console.warn('Firebase Messaging not supported in this browser:', error);
}

export const VAPID_KEY = process.env.REACT_APP_FIREBASE_VAPID_KEY || '';

export async function requestNotificationPermission(): Promise<string | null> {
  if (!messaging) {
    console.warn('Firebase Messaging not available');
    return null;
  }

  try {
    // Check if notifications are supported
    if (!('Notification' in window)) {
      console.warn('This browser does not support notifications');
      return null;
    }

    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      console.log('Notification permission denied');
      return null;
    }

    // Get FCM token
    const token = await getToken(messaging, {
      vapidKey: VAPID_KEY || undefined
    });
    console.log('FCM Token obtained:', token ? token.substring(0, 20) + '...' : 'null');
    return token;
  } catch (error) {
    console.error('Error getting FCM token:', error);
    return null;
  }
}

export function onForegroundMessage(callback: (payload: any) => void): (() => void) | undefined {
  if (!messaging) {
    console.warn('Firebase Messaging not available');
    return undefined;
  }

  return onMessage(messaging, (payload) => {
    console.log('Foreground message received:', payload);
    callback(payload);
  });
}

export { messaging };
